// Çalışanın iki adresi var: `address` (ev) ve `workAddress` (iş). Hangisinin
// "ana adres" sayılacağı Employees dokümanındaki `primaryAddress` alanında
// tutulur ve çalışan kendi profilinden seçer.
//
// Alan hiç yoksa (eski kayıtlar) ya da iş adresi ana seçilmiş ama boşsa ev
// adresine düşülür; ev adresi zorunlu alan olduğu için her zaman geçerli bir
// ana adres üretilir.

export const PRIMARY_ADDRESS_HOME = 'home';
export const PRIMARY_ADDRESS_WORK = 'work';

export const PRIMARY_ADDRESS_LABELS = {
  [PRIMARY_ADDRESS_HOME]: 'Ev Adresi',
  [PRIMARY_ADDRESS_WORK]: 'İş Adresi',
};

// Listelerde ve kartlarda kullanılan ortak rozet metni
export const PRIMARY_ADDRESS_BADGE = 'Ana Adres';

const hasValue = (value) =>
  typeof value === 'string' ? value.trim().length > 0 : Boolean(value);

// Çalışanın geçerli ana adres anahtarı: 'home' | 'work'
export const getPrimaryAddressKey = (employee) => {
  if (
    employee &&
    employee.primaryAddress === PRIMARY_ADDRESS_WORK &&
    hasValue(employee.workAddress)
  ) {
    return PRIMARY_ADDRESS_WORK;
  }
  return PRIMARY_ADDRESS_HOME;
};

export const isPrimaryAddress = (employee, addressKey) =>
  getPrimaryAddressKey(employee) === addressKey;

// Ana adresin anahtarı, etiketi ve değeri
export const getPrimaryAddress = (employee) => {
  const key = getPrimaryAddressKey(employee);
  return {
    key,
    label: PRIMARY_ADDRESS_LABELS[key],
    value:
      (key === PRIMARY_ADDRESS_WORK ? employee?.workAddress : employee?.address) || '',
  };
};
